export default __webpack_public_path__ + "static/media/categoria_conta_asistente.527f968e.svg";